import axios from 'axios'
import { Flow, FlowValidationParameters, FlowValidationResult } from '../features/flow/types'

export const fetchFlows = () => axios.get('/flows')

export const fetchFlowInfo = (entityId: any) => axios.get<Flow>(`/flows/${entityId}`)

export const validateFlow = (flow: FlowValidationParameters) =>
  axios.post<FlowValidationResult>('/flows/validate', flow)

export const saveFlow = (flow: FlowValidationParameters) => axios.post<Flow>('/flows', flow)

export const updateFlow = (entityId: string, data: FlowValidationParameters) =>
  axios.put<Flow>(`/flows/${entityId}`, data)

export const deleteFlow = (entityId: string) => axios.delete(`/flows/${entityId}`)
